import React from 'react';
import { Row, Col, Form, Checkbox } from 'antd';
import PropType from 'prop-types';
import './style.css';


function ModuleForm ({ initialModules }) {
  const form = Form.useFormInstance();

  // Handle single checkbox change - sets all 4 permissions
  const handleModuleCheckboxChange = (moduleName, checked) => {
    form.setFieldsValue({
      [`${moduleName}-view`]: checked,
      [`${moduleName}-create`]: checked,
      [`${moduleName}-edit`]: checked,
      [`${moduleName}-print`]: checked,
    });

    // Trigger validation for module permission validator
    form.validateFields(['modulePermissionValidator']).catch(() => {});
  };

  return (
    <div className="user-type-module-form-container">
      {initialModules
        .filter(item => item.moduleName !== 'DASHBOARD')
        .map((item, index) => {
        return (
          <div key={item.moduleName} className="module-item">
            <Row gutter={12} align="middle">
              <Col flex="auto">
                <Form.Item
                  name={`${item.moduleName}-module`}
                  className="module-checkbox"
                  valuePropName='checked'
                  style={{ marginBottom: 0 }}
                >
                  <Checkbox
                    onChange={(e) => handleModuleCheckboxChange(item.moduleName, e.target.checked)}
                  >
                    {item.moduleName}
                  </Checkbox>
                </Form.Item>
              </Col>

              {/* Hidden form fields to store actual permission values */}
              <Form.Item name={`${item.moduleName}-view`} valuePropName='checked' hidden>
                <Checkbox />
              </Form.Item>
              <Form.Item name={`${item.moduleName}-create`} valuePropName='checked' hidden>
                <Checkbox />
              </Form.Item>
              <Form.Item name={`${item.moduleName}-edit`} valuePropName='checked' hidden>
                <Checkbox />
              </Form.Item>
              <Form.Item name={`${item.moduleName}-print`} valuePropName='checked' hidden>
                <Checkbox />
              </Form.Item>
            </Row>
          </div>
        );
      })}
    </div>
  );
};

ModuleForm.PropType = {
  initialModules: PropType.array
}

export default ModuleForm;